import ApiService from '../apiservice';
import ErroValidacao  from '../exception/ErroValidacao'

class ExportacaoService extends ApiService{

    constructor(){
        super('/api/relatorio')
    }

    gerarExportacaoPorCliente(credenciais){
        return this.put('/exportacaoPorCliente', credenciais)
    }

    validar (campos){
        const erros = [];
        if (erros && erros.length>0){
            throw new ErroValidacao(erros);
        }

    }

    limparDiretorioExportacao(){
        return this.put('/removerExportacao')
    }
    

}
export default ExportacaoService;

